import { createSlice } from "@reduxjs/toolkit";

export const recruitmentListSlice = createSlice({
  name: "recruitmentList",
  initialState: {
    BANNER: [],
    JOB: [],
    PAGE: 1,
    CITY: "",
    CATEGORY: "",
    INDUSTRY: "",
    EDUCATION: "",
    SALARY: "",
  },
  reducers: {
    setBanner: (state, action) => {
      state.BANNER = action.payload;
    },
    setJob: (state, action) => {
      state.JOB = action.payload;
    },
    appendJob: (state, action) => {
      state.JOB = [...state.JOB, ...action.payload];
    },
    setPage: (state, action) => {
      state.PAGE = action.payload;
    },
    setCity: (state, action) => {
      state.CITY = action.payload;
    },
    setCategory: (state, action) => {
      state.CATEGORY = action.payload;
    },
    setIndustry: (state, action) => {
      state.INDUSTRY = action.payload;
    },
    setEducation: (state, action) => {
      state.EDUCATION = action.payload;
    },
    setSalary: (state, action) => {
      state.SALARY = action.payload;
    },
    initializeFromParams: (state, action) => {
      const { city, category, industry, education, salary } = action.payload;
      state.CITY = city || "";
      state.CATEGORY = category || "";
      state.INDUSTRY = industry || "";
      state.EDUCATION = education || "";
      state.SALARY = salary || "";
      state.JOB = [];
      state.PAGE = 1;
    },
    resetAll: (state) => {
      state.BANNER = [];
      state.JOB = [];
      state.PAGE = 1;
      state.CITY = "";
      state.CATEGORY = "";
      state.INDUSTRY = "";
      state.EDUCATION = "";
      state.SALARY = "";
    },
  },
});

export const {
  setBanner,
  setJob,
  appendJob,
  setPage,
  setCity,
  setCategory,
  setIndustry,
  setEducation,
  setSalary,
  initializeFromParams,
  resetAll,
} = recruitmentListSlice.actions;

export default recruitmentListSlice.reducer;
